import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { api, scrollToId } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { CondoSection } from "@/components/CondoSection";
import { FleetSection } from "@/components/FleetSection";
import { PackageSection } from "@/components/PackageSection";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";
import { ConciergeChat } from "@/components/ConciergeChat";

export default function Home() {
  const [catalog, setCatalog] = useState(null);
  const [selection, setSelection] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    api.get("/catalog").then((r) => setCatalog(r.data)).catch(() => {});
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const reserve = useCallback((type, itemId) => {
    setSelection({ type, itemId, ts: Date.now() });
    scrollToId("booking");
  }, []);

  return (
    <div data-testid="home-page" className="bg-obsidian">
      <Navbar />
      <Hero />
      <Marquee />
      <CondoSection condo={catalog?.condo} onReserve={reserve} />
      <FleetSection fleet={catalog?.fleet ?? []} onReserve={reserve} />
      <PackageSection pkg={catalog?.package} onReserve={reserve} />
      <BookingSection catalog={catalog} selection={selection} />
      <Footer />
      <ConciergeChat />
    </div>
  );
}
